// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveAPITokenUserDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import APITokenUserDTO from '../models/APITokenUserDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    apiTokenUserId: string | null;
    apiTokenUser: APITokenUserDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            apiTokenUserId: '00000000-0000-0000-0000-000000000000',
            apiTokenUser: null,
        },
        initValues);
    },
    apiTokenUserId: 'apiTokenUserId',
    apiTokenUser: 'apiTokenUser',
}

interface Result extends ResultDTO {
    apiTokenUser: APITokenUserDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            apiTokenUser: null,
        },
        initValues);
    },
    apiTokenUser: 'apiTokenUser',
}

export { Request, Result };